import React from "react";
import { Link } from "expo-router";
import { Text, View } from "tamagui";

export interface SignupErrorMessageProps {
  message: string | undefined | null;
}

export const SignupErrorMessage: React.FC<SignupErrorMessageProps> = (
  props,
) => {
  if (!props.message) return null;

  if (props.message === "CONFLICT") {
    return (
      <View gap={"$2"}>
        <Text fontFamily={"$body"} color={"$error-500"}>
          Ця електронна адреса вже використовується.
        </Text>
        <Text fontFamily={"$body"}>
          <span>Спробуйте </span>
          <Link href="/auth" asChild>
            <Text
              cursor="pointer"
              hoverStyle={{ color: "$lightblue-800" }}
              textDecorationLine="underline"
            >
              увійти
            </Text>
          </Link>
          <span> або </span>
          <Link href="/auth/forgot-password" asChild>
            <Text
              cursor="pointer"
              hoverStyle={{ color: "$lightblue-800" }}
              textDecorationLine="underline"
            >
              відновити пароль
            </Text>
          </Link>
          <span>.</span>
        </Text>
      </View>
    );
  }

  return (
    <Text fontFamily={"$body"} color={"$error-500"}>
      {props.message}
    </Text>
  );
};
